import { Box, VStack } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { dropDownFormStyle } from '../formStyles';
import { forwardRef } from 'react';

const ChakraSelect = forwardRef((props, ref) => (
    <Select selectedOptionColor="brand" ref={ref} {...props} />
));
ChakraSelect.displayName = 'ChakraSelect';

const DropDown = ({
    field,
    data,
    shownValue,
    width,
    readOnly = false,
    isMulti = false,
    multiValue,
    noPadding,
    alphabetical = true,
    minWidth = '410px',
    form,
    ...props
}) => {
    // Provide safe defaults if form is not present
    const setValues = form?.setValues || (() => Promise.resolve());
    const values = form?.values || {};
    const validateField = form?.validateField || (() => {});
    const touched = form?.touched || {};
    const setTouched = form?.setTouched || (() => {});

    const getValue = () => {
        if (isMulti) {
            if (!Array.isArray(multiValue) || !data || data.length === 0) {
                return [];
            }
            const selectedOptions = multiValue
                .map((id) => data?.find((item) => item.id === id))
                .filter(Boolean);
            return selectedOptions;
        } else {
            if (!data || data.length === 0) return '';
            // Use field.value from Formik if it exists and is not empty, otherwise use currentId prop
            const fieldValue = field?.value;
            const valueToUse =
                fieldValue !== undefined &&
                fieldValue !== null &&
                fieldValue !== ''
                    ? fieldValue
                    : props.currentId;

            const foundItem = data?.find(
                (item) => (item[props.selectedId] || item.id) === valueToUse,
            );
            return foundItem || '';
        }
    };
    return (
        <Box
            flex="1"
            sx={{
                paddingTop: noPadding ? '0' : '15px',
            }}>
            <VStack alignItems="normal" width={width || '90%'}>
                <ChakraSelect
                    {...field}
                    {...props}
                    minWidth={minWidth}
                    width="100%"
                    height="auto"
                    data-walkthroughid={props.walkthroughId}
                    value={getValue()}
                    isMulti={isMulti}
                    options={
                        alphabetical && data
                            ? [...data].sort((a, b) => {
                                  const getLabel = (i) => {
                                      if (typeof shownValue === 'function')
                                          return shownValue(i) ?? '';
                                      return String(
                                          i[shownValue] || i.name || '',
                                      );
                                  };
                                  return getLabel(a).localeCompare(getLabel(b));
                              })
                            : data
                    }
                    closeMenuOnSelect={isMulti ? false : undefined}
                    tagVariant={isMulti ? 'solid' : undefined}
                    placeholder={props.placeholder}
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    getOptionLabel={(i) => {
                        if (typeof shownValue === 'function') {
                            return shownValue(i);
                        }
                        const label = i[shownValue] || i.name;
                        return props.isPhoneNumber && !isNaN(label)
                            ? `+${label}`
                            : label;
                    }}
                    getOptionValue={(i) => i.id}
                    chakraStyles={dropDownFormStyle(props.darkMode, isMulti)}
                    isLoading={props.isLoading}
                    isDisabled={props.isLoading || props.isDisabled || readOnly}
                    isSearchable={!readOnly}
                    onChange={(item) => {
                        if (readOnly) return;
                        // For multiselect, item is an array
                        if (isMulti) {
                            const selectedIds = item
                                ? item.map((i) => i.id)
                                : [];
                            props.handleSelectChange(selectedIds, props.name);
                            setValues({
                                ...values,
                                [props.name]: selectedIds,
                            }).then(() => {
                                validateField(props.name);
                            });
                        } else {
                            props.handleSelectChange(item, props.name);
                            setValues({
                                ...values,
                                [props.name]: item?.id || '',
                            }).then(() => {
                                validateField(props.name);
                            });
                        }
                    }}
                    onBlur={() => {
                        if (readOnly) return;

                        setTouched({
                            ...touched,
                        });
                    }}
                    onMenuOpen={() => {
                        if (readOnly) return false;
                    }}
                />
            </VStack>
        </Box>
    );
};

export default DropDown;
